var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReplay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 7,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 3.125 3.75 0v1.875c2.813 0 5 .625 6.25 3.75-1.875-1.563-3.75-1.875-6.25-1.25V6.25L0 3.125Z",
  clipRule: "evenodd"
})));
export { SvgReplay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEwIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAzLjEyNUwzLjc1IDBWMS44NzVDNi41NjI1IDEuODc1IDguNzUgMi41IDEwIDUuNjI1QzguMTI1IDQuMDYyNSA2LjI1IDMuNzUgMy43NSA0LjM3NVY2LjI1TDAgMy4xMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";